import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetCategory } from "../../redux/slices/GetCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import WebsiteFooter from "../../Fotter";
function ViewAllCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state.category);

  useEffect(() => {
    dispatch(GetCategory());
  }, [dispatch]);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const _handleClick = (name) => {
    const url =
      name?.name && name?._id
        ? name?.category
          ? `/ShowCategoryData/${name.name}/${name._id}/${name.category}`
          : `/ShowCategoryData/${name.name}/${name._id}`
        : "";
    navigate(url);
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="  min-h-screen">
      <div className="sm:mt-28 mt-20 flex mx-auto items-center  w-[90%]  justify-between ">
        <button
          onClick={() => navigate(-1)}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center "
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>
        <h1 className="text-lg m font-bold   text-center">
          View All Categories
        </h1>
        <h1></h1>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-8 gap-5 mt-2  w-[95%] p-2 mx-auto">
        {AllCategory?.map((category, index) => (
          <div
            key={index}
            onClick={() => _handleClick(category)}
            className="flex flex-col items-center p-1 cursor-pointer rounded-lg bg-white hover:shadow-lg transition-shadow "
          >
            <img
              src={category.image}
              alt={category.name}
              className="w-16 h-16 rounded-full object-cover border border-gray-200"
            />
            <p className="text-center font-medium text-gray-700 line-clamp-1">
              {category.name}
            </p>
          </div>
        ))}
      </div>
      <WebsiteFooter />
    </div>
  );
}

export default ViewAllCategory;
